module.exports = __webpack_public_path__ + "static/media/MobileFourOFour.7de100e7.png";